import { Box, Stack, StackProps, useTheme } from '@mui/material';
import { FormattedMessage, FormattedNumber } from 'react-intl';
import { PoolActionLabel, PoolRow } from '@synergy/components-next';
import { PoolMath } from '@synergy/utils';
import { ReactElement } from 'react';

import { WishListArticle } from '../../../../models/wish-list';

export interface SupplierTableRowProps extends StackProps {
    article: WishListArticle;
    netPrice: number;
}

export const ArticlePriceMobile = (props: SupplierTableRowProps): ReactElement => {
    const theme = useTheme();
    const { article, netPrice, ...stackProps } = props;

    return (
        <Stack typography="body2" {...stackProps} gap={0.5}>
            <Box>
                <Box color={article.specialPrice ? theme.palette.error.dark : theme.palette.common.black}>
                    <FormattedNumber value={netPrice} currency={article.currency} style="currency" />
                    &nbsp;/&nbsp;
                    {article.orderUnit}
                </Box>
                {article.specialPrice && (
                    <PoolRow gap={0.5}>
                        <Box sx={{ textDecoration: 'line-through' }}>
                            <FormattedNumber value={article.mainPrice} currency={article.currency} style="currency" />
                        </Box>
                        <Box color={theme.palette.error.dark}>
                            <FormattedNumber
                                value={-PoolMath.getPercentDifference(article.mainPrice, article.specialPrice.price)}
                                style="percent"
                            />
                        </Box>
                    </PoolRow>
                )}
            </Box>
            {article.isBestPrice && (
                <Box>
                    <PoolActionLabel variant="small" color="secondary" hasSkew={false}>
                        <FormattedMessage id="app.filter.bestprice" />
                    </PoolActionLabel>
                </Box>
            )}

            {article.contentUnit && (
                <Box color="grey.700">
                    (
                    <FormattedNumber
                        value={PoolMath.round(
                            (article.specialPrice?.price ?? article.mainPrice) / (article.contentQuantity ?? 1)
                        )}
                        currency={article.currency}
                        style="currency"
                    />
                    &nbsp;/&nbsp;
                    {article.contentUnit})
                </Box>
            )}
        </Stack>
    );
};
